import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { Router } from "@angular/router";
import { GlobalMessageService } from "../services/global-message.service";
import { LoadingService } from "src/app/shared/services/loading.service";

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(
    public router: Router,
    private readonly globalMessageService: GlobalMessageService,
    private readonly loadingService: LoadingService) { }

  intercept (
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Verificar si la petición debe saltar el loading
    const skipLoading = req.headers.has('X-Skip-Loading');
    
    if (!skipLoading) {
      this.loadingService.show();
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (!skipLoading) {
          this.loadingService.hide();
        }
      }),
      catchError(error => {
        try {
          const status = error && error.status ? error.status : null;
          if (status === 401) {
            this.globalMessageService.setPayload({ type: 'error', title: 'No autorizado', body: 'Tu sesión ha expirado o no estás autenticado.' });
          } else if (status === 403) {
            this.globalMessageService.setPayload({ type: 'error', title: 'No autorizado', body: 'No tienes permisos para realizar esta acción.' });
          }
        } catch (e) {
          // swallow
        }
        return throwError(() => error.error || error);
      })
    );
  }
}
